import { createRouter, createWebHistory } from "vue-router";
import LoginView from "../views/LoginView.vue";
import SettingView from "../views/SettingView.vue";
import ApplicantListView from "../views/ApplicantListView.vue";
import ApplicantPreviewView from "../views/ApplicantPreviewView.vue";
import ApplicantRegisterView from "../views/ApplicantRegisterView.vue";
import JobTypeRegisterView from "../views/JobRegisterView.vue";
import UserRegisterView from "../views/UserRegisterView.vue";
import UserPermissionView from "../views/UserPermissionView.vue";
import ChangePasswordView from "../views/ChangePasswordView.vue";
import ErrorPage from "../views/ErrorPage.vue";
import store from "../store/index.js";

const routes = [
    {
        path: "/",
        name: "login",
        component: LoginView,
        meta: { title: "ログイン" },
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem('currentRoute') === null) {
                next();
                localStorage.clear();
            } else {
                next({name : 'applicantList' });
            }
        }
    },
    {
        path: '/changePassword',
        name: 'changePassword',
        component: ChangePasswordView,
        meta: { requiresAuth: true, title: "リセットパスワード" },
    },
    {
        path: "/userRegister",
        name: "userRegister",
        component: UserRegisterView,
        meta: { requiresAuth: true, title: "ユーザー登録" },
        beforeEnter: (to, from, next) => {
            if (store.state.role !== 'M') {
                next(localStorage.getItem('currentRoute'));
            } else {
                next();
            }
        }
    },
    {
      path: "/userPermission/:uid?",
      name: "userPermission",
      component: UserPermissionView,
      meta: { requiresAuth: true, title: "ユーザー制限" },
      beforeEnter: (to, from, next) => {
        if (store.state.role !== 'M') {
            next(localStorage.getItem('currentRoute'));
        } else {
            next();
        }
      }
    },
    {
        path: "/setting",
        name: "setting",
        component: SettingView,
        meta: { requiresAuth: true, title: "各種設定" },
    },
    {
        path: "/applicantList",
        name: "applicantList",
        component: ApplicantListView,
        meta: { requiresAuth: true, title: "応募者一覧" },
    },
    {
        path: '/applicantPreview/:uid?',
        name: 'applicantPreview',
        component: ApplicantPreviewView,
        meta: { requiresAuth: true, title: "応募者プレビュー" },
        props: true,
        beforeEnter: (to, from, next) => {
            if (store.state.permission.data.preview === 1) {
                next();
            } else {
                next(localStorage.getItem('currentRoute'));
            }
        }
    },
    {
        path: "/applicantRegister/:uid?",
        name: "applicantRegister",
        component: ApplicantRegisterView,
        meta: { requiresAuth: true, title: "応募者登録" },
        beforeEnter: (to, from, next) => {
            if (store.state.permission.data.app_create === 1 || store.state.permission.data.app_update === 1 || store.state.permission.data.app_delete === 1) {
                next();
            } else {
                next(localStorage.getItem('currentRoute'));
            }
        }
    },
    {
        path: "/jobTypeRegister",
        name: "jobTypeRegister",
        component: JobTypeRegisterView,
        meta: { requiresAuth: true, title: "職種登録" },
        beforeEnter: (to, from, next) => {
            if (store.state.permission.data.job_create === 1 || store.state.permission.data.job_update === 1 || store.state.permission.data.job_delete === 1) {
                next();
            } else {
                next(localStorage.getItem('currentRoute'));
            }
        }
    },
    {
        path: "/errorPage",
        name: "errorPage",
        component: ErrorPage,
        props: true,
        meta: { requiresAuth: true, title: "エラーページ" },
        beforeEnter: (to, from, next) => {
            if (store.state.auth.isAuthenticated) {
                const route_name = to.name.toLowerCase();
                if (route_name == "errorpage" && !localStorage.getItem('errorFlag')) {
                    next(localStorage.getItem('currentRoute'));
                } else {
                    next();
                }
            } else {
                next('/');
            }
        }
    },
    {
        path: "/:pathMatch(.*)",
        redirect: "/applicantList"
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

var isAuthenticated = () => store.state.auth.isAuthenticated;
router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    const route_name = to.name.toLowerCase();
    if (isAuthenticated()) {
        if ( route_name !== "errorpage" && route_name !== "login") {
            if(route_name == "userregister" || route_name == "userpermission"){
                if(store.state.role == 'M'){
                    localStorage.setItem("currentRoute", to.path);
                }
            }
            else if (route_name == "applicantpreview"){
                if (store.state.permission.data.preview === 1) {
                    localStorage.setItem("currentRoute", to.path);
                }
            }
            else if (route_name == "applicantregister"){
                if (store.state.permission.data.app_create === 1 || store.state.permission.data.app_update === 1 || store.state.permission.data.app_delete === 1) {
                    localStorage.setItem("currentRoute", to.path);
                }
            }
            else if (route_name == "jobtyperegister"){
                if (store.state.permission.data.job_create === 1 || store.state.permission.data.job_update === 1 || store.state.permission.data.job_delete === 1) {
                    localStorage.setItem("currentRoute", to.path);
                }
            }
            else{
                localStorage.setItem("currentRoute", to.path);
            }
        }
        next();
    } else if (to.meta.requiresAuth) {
        next("/");
    } else {
        next();
    }
});

export default router;